<template>
    <div>
        <v-autocomplete
                v-model="selectedTrainer"
                :label="label"
                item-text="firstName"
                item-value="id"
                :items="trainers"
                type="select"
                return-object
                @change="emitSelected"
                :error-messages="errorMessages"
        >

            <template v-slot:selection="data">
                <template v-if="data.item.firstName">

                    <v-list-item-avatar>
                        <TrainerAvatar :trainer="data.item" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{data.item.firstName}} {{data.item.lastName}}</v-list-item-title>
                    </v-list-item-content>
                </template>
            </template>

            <template v-slot:item="data">
                <template v-if="data.item.firstName">
                    <v-list-item-avatar>
                        <TrainerAvatar :trainer="data.item" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{data.item.firstName}} {{data.item.lastName}}</v-list-item-title>
                    </v-list-item-content>
                </template>
            </template>

        </v-autocomplete>
    </div>
</template>

<script>
    import TRAINERS from "../../graphql/TrainerAllActive.gql";
    import TrainerAvatar from "../Trainer/TrainerAvatar";

    export default {
        components:{TrainerAvatar},
        props: {
            value: {
                type: [String],
                default: ""
            },
            label: {
                type: String,
                default: 'Trainer'
            }      ,
            errorMessages: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                selectedTrainer: {
                    id: this.value
                }
            }
        },
        apollo: {
            trainers: {
                query: TRAINERS,
                update: data => data.activeTrainers
            },
        },
        methods: {
            emitSelected(trainer) {
                this.$emit('input', trainer.id)
                this.$emit('selected', trainer)
            }
        },
    }
</script>
